import { useMemo } from 'react'
import { ClientDetailsPayloadInterface } from 'storeTypes'
import { sortHandler, filterHandler, constants } from 'helpers'
import { processRemainingPayments } from 'pages/village/helpers/processClientsRemainingPayments'

export const useProcessedClientList = ({
    activeClients = [],
    potentialClients = [],
    selectedFilter,
    isActiveClientTab,
    isPotentialClientTab,
    filteringCondition
}: {
    activeClients: ClientDetailsPayloadInterface[]
    potentialClients: ClientDetailsPayloadInterface[]
    selectedFilter: string | number | null
    isActiveClientTab: boolean
    isPotentialClientTab: boolean
    prevSearchValue: string
    filteringCondition: (selectedFilter: string | number) => void
}) => {
    const { SORT_TYPE, SORT_DIRECTION } = constants

    let incompleteClientsLength

    const processedClientList = useMemo(() => {
        const clientsWithRemainingPayments =
            processRemainingPayments(activeClients)

        const incompleteClientList: ClientDetailsPayloadInterface[] = []
        const finishersClientList: ClientDetailsPayloadInterface[] = []

        clientsWithRemainingPayments.forEach((client) => {
            client.balance >= client.all_enrollment
                ? finishersClientList.push(client)
                : incompleteClientList.push(client)
        })

        const sortedIncompleteClients = sortHandler(
            [...incompleteClientList],
            'payment_progress',
            SORT_TYPE.ALPHA_NUMERIC,
            SORT_DIRECTION.DESCENDING
        )

        incompleteClientsLength = sortedIncompleteClients.length

        const combinedClientList = [
            ...sortedIncompleteClients,
            ...finishersClientList
        ]

        if (isActiveClientTab && selectedFilter) {
            return filterHandler(
                combinedClientList,
                filteringCondition(selectedFilter)
            )
        }

        return combinedClientList
    }, [activeClients, selectedFilter, isActiveClientTab])

    const processedPotentialClientList = useMemo(() => {
        potentialClients = sortHandler(
            [...potentialClients],
            'recent_year_delivered',
            SORT_TYPE.ALPHA_NUMERIC,
            SORT_DIRECTION.ASCENDING
        )

        const filteredData =
            isPotentialClientTab && selectedFilter
                ? filterHandler(
                      [...potentialClients],
                      filteringCondition(selectedFilter)
                  )
                : potentialClients

        return filteredData
    }, [potentialClients, selectedFilter, isPotentialClientTab])

    return {
        processedClientList,
        processedPotentialClientList,
        nbOfIncompleteClients: incompleteClientsLength
    }
}
